<template>
  <div class="flex flex-wrap-reverse items-center flex-grow justify-between">
    <div class="flex flex-wrap-reverse items-center">
      <!-- ADD NEW -->
      <div
        class="
          p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between
          text-lg font-medium text-base text-primary border border-solid border-primary
        "
        @click="addNewData"
        v-if="showAddButton"
      >
          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
          <span class="ml-2 text-base text-primary">Adicionar</span>
      </div>
    </div>

    <!-- ITEMS PER PAGE -->
    <vs-dropdown
      vs-trigger-click
      class="cursor-pointer mb-4 mr-4"
    >
      <div
        class="
          p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg
          cursor-pointer flex items-center justify-between font-medium
        "
      >
        <span class="mr-2">
          Registros por página: <strong>{{ itemsPerPage }}</strong>
        </span>
        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
      </div>
      <vs-dropdown-menu>
        <vs-dropdown-item @click="changeItemsPerPage(5)">
          <span>5</span>
        </vs-dropdown-item>
        <vs-dropdown-item @click="changeItemsPerPage(10)">
          <span>10</span>
        </vs-dropdown-item>
        <vs-dropdown-item @click="changeItemsPerPage(15)">
          <span>15</span>
        </vs-dropdown-item>
        <vs-dropdown-item @click="changeItemsPerPage(20)">
          <span>20</span>
        </vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
export default {
  name: 'header-list',
  props: {
    itemsPerPage: Number,
    showAddButton: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    changeItemsPerPage(qty) {
      this.$emit("changeItemsPerPage", qty)
    },
    addNewData() {
      this.$emit("emitAddNewData")
    }
  }
}
</script>

<style lang="scss">
#custom-header-wrapper {
  flex: 1;
}

#custom-table-list {
  .vs-con-table {

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;


      tr{
        box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
        td{
          padding: 10px;
          &:first-child{
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }
          &:last-child{
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }
          &.img-container {
            // width: 1rem;
            // background: #fff;

            span {
              display: flex;
              justify-content: flex-start;
            }

            .product-img {
              height: 110px;
            }
          }
        }
        td.td-check{
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>